export function isXverseInAppBrowser() {
    return typeof window.ReactNativeWebView !== "undefined";
}
